import Modal from "@afa-shared/afa-components/dist/Modal";
import CompetitionForm from "@components/QuizBlock/Forms/CompetitionForm/CompetitionForm";
import { setQuizModalClosed } from "@utils/globalClassHelper";
import { pixelsToRem } from "@utils/sizeHelper";
import { RefObject, useEffect, useRef } from "react";

import { useEscape } from "hooks/useEscape";
import { useTab } from "hooks/useTab";

import modalStyles from "../Modal.module.css";

interface IQuizCompetitionFormModal {
  handleModalClose: () => void;
  setFormIsSubmitted: () => void;
  quizId: string;
  containerRef: RefObject<HTMLDivElement>;
}

const QuizCompetitionFormModal = ({
  handleModalClose,
  setFormIsSubmitted,
  quizId,
  containerRef,
}: IQuizCompetitionFormModal) => {
  const refs = {
    modalCloseButton: useRef(null),
    formSubmitButton: useRef(null),
    hiddenTabHelperTop: useRef(null),
    hiddenTabHelperBottom: useRef(null),
  };

  useEffect(() => {
    refs?.hiddenTabHelperTop?.current?.focus();
    return () => {
      setQuizModalClosed();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEscape(containerRef, () => {
    handleModalClose();
  });

  useTab(
    () => {
      if (document?.activeElement === refs?.formSubmitButton?.current) {
        refs.hiddenTabHelperTop?.current?.focus();
      }
    },
    () => {
      if (
        document?.activeElement === refs?.modalCloseButton?.current ||
        document?.activeElement === refs?.hiddenTabHelperTop?.current
      ) {
        refs.hiddenTabHelperBottom?.current?.focus();
      }
    },
  );

  return (
    <div className={modalStyles.modalOverlay}>
      <div className={`${modalStyles.modalWrapper} ${modalStyles.narrow}`}>
        <div ref={refs.hiddenTabHelperTop} tabIndex={-1} data-temp-keep-index />
        <Modal
          modalHeading="Delta i tävlingen"
          modalOnClose={() => handleModalClose()}
          modalMaxHeight={pixelsToRem(813)}
          modalCloseButtonRef={refs.modalCloseButton}
          children={
            <div className={modalStyles.modalContent}>
              <CompetitionForm
                submitButtonRef={refs.formSubmitButton}
                setFormIsSubmitted={setFormIsSubmitted}
                closeModal={() => handleModalClose()}
                quizId={quizId}
              />
            </div>
          }
        />
        <div ref={refs.hiddenTabHelperBottom} tabIndex={-1} data-temp-keep-index />
      </div>
    </div>
  );
};

export default QuizCompetitionFormModal;
